import {
  isSameDay,
  areIntervalsOverlapping,
  isBefore,
  isAfter,
  format,
} from 'date-fns'

export const buildPlacementOptions = (placements) =>
  placements.map((placement) => ({
    id: placement.id,
    title: placement.name,
    removable: true,
  }))

export const getDuration = (scheduledAt, takedownScheduledAt) => {
  let takedownDate = null
  const startDate = format(new Date(scheduledAt), 'MMMM d, yyyy')

  if (takedownScheduledAt && takedownScheduledAt !== 'Invalid date') {
    takedownDate = format(new Date(takedownScheduledAt), 'MMMM d, yyyy')
  }

  return takedownDate !== null
    ? `${startDate} - ${takedownDate}`
    : `${startDate}`
}

export const isInDateRange = (post, scheduledAt, takedownScheduledAt) => {
  const placementPostScheduledAt = new Date(post.scheduled_at)
  const postScheduledAt = new Date(scheduledAt)

  if (post.takedown_scheduled_at !== null) {
    const placementPostTakedownScheduledAt1 = new Date(
      post.takedown_scheduled_at
    )

    if (takedownScheduledAt !== null) {
      const postTakedownScheduledAt = new Date(takedownScheduledAt)

      if (
        !placementPostScheduledAt ||
        !placementPostTakedownScheduledAt1 ||
        !postScheduledAt ||
        postTakedownScheduledAt
      )
        return false

      return !areIntervalsOverlapping(
        {
          start: placementPostScheduledAt,
          end: placementPostTakedownScheduledAt1,
        },
        {
          start: postScheduledAt,
          end: postTakedownScheduledAt,
        }
      )
    }

    const isAfterStartDate = isAfter(postScheduledAt, placementPostScheduledAt)
    const isBeforeEndDate = isBefore(
      postScheduledAt,
      placementPostTakedownScheduledAt1
    )
    const isSameDayAsStart = isSameDay(
      postScheduledAt,
      placementPostScheduledAt
    )
    const isSameDayAsEnd = isSameDay(
      postScheduledAt,
      placementPostTakedownScheduledAt1
    )
    // if placement post scheduled date falls within date range
    return !(
      (isAfterStartDate && isBeforeEndDate) ||
      isSameDayAsStart ||
      isSameDayAsEnd
    )
  }

  return !isSameDay(placementPostScheduledAt, postScheduledAt)
}

export const calculateOpenPlacements = (props) => {
  const { accountId, postId, scheduledAt, takedownScheduledAt, placements } =
    props
  const mappedOpenPlacements = []
  if (!placements.length) return []

  placements.forEach((placement) => {
    const mappedPlacement = {
      name: placement.name,
      id: placement.id,
      isOpen: true,
      isActivePost: false,
    }

    if (placement.posts && placement.posts.length > 0) {
      const placementPosts = placement.posts.filter(
        (p) =>
          p.relationships.account && p.relationships.account.id === accountId
      )

      if (placementPosts.length) {
        let x = true
        for (let i = 0; i < placementPosts.length; i += 1) {
          if (postId === placementPosts[i].id)
            mappedPlacement.isActivePost = true
          if (x === false) {
            break
          }
          x = isInDateRange(placementPosts[i], scheduledAt, takedownScheduledAt)
        }
        mappedPlacement.isOpen = x
      }
    }

    mappedOpenPlacements.push(mappedPlacement)
  })

  return mappedOpenPlacements
}

const singlePlacementAvailability = (placement, props) => {
  const activePlacement = props.placements.find((p) => p.id === placement.id)
  let x = true
  for (let i = 0; i < activePlacement.posts.length; i += 1) {
    if (x === false) {
      break
    }
    if (props.postId !== activePlacement.posts[i].id) {
      x = isInDateRange(
        activePlacement.posts[i],
        props.scheduledAt,
        props.takedownScheduledAt
      )
    }
  }
  return x
}

export const disassignPlacement = (saved, props) =>
  saved.map((placement) => {
    if (placement.isActivePost) {
      placement.isOpen = singlePlacementAvailability(placement, props)
    }
    return placement
  })

export const assignPlacement = (mapped, saved, newValue, prevValue, props) =>
  mapped.map((placement, index) => {
    if (placement.id === newValue.id) placement.isOpen = false
    if (placement.id === prevValue.id) {
      if (saved[index].isActivePost) {
        placement.isOpen = singlePlacementAvailability(placement, props)
      } else {
        placement.isOpen = saved[index].isOpen
      }
    }
    return placement
  })
